<template>
    <div class="editform">
        <Form
            ref="dInfo"
            label-postion="left"
            :model="dInfo"
            :rules="ruleValidate"
            :label-width="90"
        >
            <FormItem label="分类名称" prop="name">
                <Input
                    v-model="dInfo.name"
                    placeholder=""
                    :maxlength="60"
                ></Input>
            </FormItem>
            <FormItem label="分类代码" prop="code">
                <Input
                    v-model="dInfo.code"
                    placeholder=""
                    :maxlength="60"
                ></Input>
            </FormItem>
            <FormItem label="是否系统内置" prop="sys">
                <Select v-model="dInfo.sys" transfer>
                    <Option
                        v-for="(item, index) in sysList"
                        :value="item.id"
                        :key="index"
                        >{{ item.text }}</Option
                    >
                </Select>
            </FormItem>
        </Form>
    </div>
</template>
<script>
import { dictAdd } from '@/api/sys-dict'
import Enum from '_u/enum'

const syss = Enum.get('YN')

export default {
    name: 'addFatherDict',
    props: {
        prodId: {
            type: [String, Number],
        },
    },
    inject: {
        $modal: {
            default: null,
        },
    },
    data() {
        return {
            //表单数据
            dInfo: {
                name: '',
                pid: '0',
                code: '',
                sys: syss.no,
            },
            syss,
            //校验规则
            ruleValidate: {
                name: [
                    {
                        required: true,
                        message: '分类名称必填',
                        trigger: 'blur',
                    },
                ],
                code: [
                    {
                        required: true,
                        message: '分类值必填',
                        trigger: 'blur',
                    },
                ],
            },
        }
    },
    computed: {
        sysList: function () {
            return this.syss.toList()
        },
    },
    methods: {},
    mounted() {
        var $dInfo = this.$refs.dInfo

        this.$modal.onBtnClick('confirm', (next, options) => {
            $dInfo.validate((valid) => {
                if (valid) {
                    this.dInfo.prodId = this.prodId
                    dictAdd(this.dInfo)
                        .then(
                            (res) => {
                                this.$Message.success(
                                    this.$t('tips.add.success')
                                )
                                return res
                            },
                            (err) => (options.closeModal = false)
                        )
                        .then((res) => {
                            next()
                        })
                } else {
                    options.closeModal = false
                    next()
                }
            })
        })
    },
}
</script>
